import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  background as backgroundColors,
  border as borderColors,
} from 'theme/palette'
import { borderWidth, opacity } from 'theme/globals'
import { get } from 'lodash'

const SIZES = {
  xs: '8px',
  sm: '10px',
  md: '12px',
}

const Dot = styled.div.withConfig({
  shouldForwardProp: prop => ![
    'size',
    'color',
    'borderWidth',
    'striped',
    'fadeIn',
    'blend',
    'hex',
    'border',
  ].includes(prop),
})`
  position: relative;
  height: ${props => SIZES[props.size]};
  width: ${props => SIZES[props.size]};
  border-radius: ${props => SIZES[props.size]};
  overflow: hidden;
  background-color: ${props => props.hex || props.theme.palette.background[props.color]?.main};
  opacity: ${props => props.blend ? get(props.theme, `globals.opacity.${props.blend}`, props.theme.globals.opacity.main) : '1'};

  ${props => props.border ? `
    border-style: solid;
    border-width: ${props.theme.globals.borderWidth[props.borderWidth]};
    border-color: ${props.theme.palette.border[props.border]};
    height: ${SIZES[props.size]};
    width: ${SIZES[props.size]};
    border-radius: ${SIZES[props.size]};
  ` : ``}

  ${props => props.striped ? `
    background: repeating-linear-gradient(150deg, ${props.hex || props.theme.palette.background[props.color]?.main}, ${props.hex || props.theme.palette.background[props.color]?.main} 1px, transparent 1px, transparent 2px);
  ` : ''}

  ${props => props.fadeIn ? `
    opacity: 0;
    animation: fade-in .2s 1s ease-in forwards;
  ` : ``}
`

Dot.propTypes = {
  fadeIn: PropTypes.bool,
  color: PropTypes.oneOf(Object.keys(backgroundColors)),
  hex: PropTypes.string,
  border: PropTypes.oneOf(Object.keys(borderColors)),
  borderWidth: PropTypes.oneOf(Object.keys(borderWidth)),
  size: PropTypes.oneOf(Object.keys(SIZES)),
  blend: PropTypes.oneOf([true, false, ...Object.keys(opacity)]),
  striped: PropTypes.bool,
}

Dot.defaultProps = {
  fadeIn: false,
  color: 'error',
  borderWidth: 'thick',
  size: 'xs',
}

export default Dot
